import dayjs from 'dayjs';
import type { Propriedade, Talhao } from '../../../@types';
import type { TalhaoAlerta } from '../../../services/alertas-talhao';

export const redirectToGleba = (propriedade: Propriedade, gleba: Talhao) => {
  const searchParams = new URLSearchParams();
  searchParams.set('propriedade', propriedade.uuid);
  searchParams.set('gleba', gleba.uuid);
  searchParams.set('date', dayjs().format('YYYY-MM-DD'));
  window.location.href = `/#!/propriedade?${searchParams}`;
};

export const getDiasUltimaAcao = (
  gleba: Talhao,
  alertasTalhoes: TalhaoAlerta[],
): number =>
  alertasTalhoes.find((alerta) => alerta.id === gleba.id)
    ?.diasDesdeAUltimaAcao ?? Infinity;
